export default "__VITE_ASSET__DYe8Pxh1__"